export const getCurrentYear = () => {
    const now = new Date()
    const year = now.getFullYear()
    return year
}